<template>
    <v-speed-dial
        v-model="fab"
        :open-on-hover="false"
        direction="bottom"
        transition="slide-x-transition"
    >
        <template v-slot:activator>
            <v-btn v-model="fab" icon>
                <v-icon large>
                    {{
                        $vuetify.breakpoint.smAndDown
                            ? 'mdi-dots-horizontal'
                            : 'mdi-dots-vertical'
                    }}
                </v-icon>
            </v-btn>
        </template>
        <v-btn large fab color="orange" @click="openFilterDialog">
            <v-icon color="white" size="35">mdi-magnify</v-icon>
        </v-btn>
        <v-btn large fab color="indigo" @click="openDateFilter">
            <v-icon color="white" size="35">mdi-calendar</v-icon>
        </v-btn>
        <v-btn large color="purple" fab @click="downloadImage">
            <v-icon color="white" size="35"> mdi-camera </v-icon>
        </v-btn>
        <v-btn large color="deep-purple" dark fab @click="openInfo">
            <v-icon size="35">mdi-information-outline</v-icon>
        </v-btn>
    </v-speed-dial>
</template>
<script>
export default {
    name: 'Dial',
    data: () => ({
        fab: false,
    }),
    methods: {
        openInfo() {
            this.$store.commit('util/isOpenLegendDialog', true);
        },
        openDateFilter() {
            this.$store.commit('reportTable/isOpenReportDateFilter', true);
        },
        openFilterDialog() {
            this.$store.commit('objectivesReport/isOpenFilterDialog', true);
        },
        downloadImage() {
            let obj = {
                elementId: 'objectivesReportTable',
                downloadName: 'proyeccion',
            };

            this.$store.dispatch('util/printThis', obj);
        },
    },
};
</script>
